var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIndonesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4307C0 7.59416 7.1635 0.430664 16 0.430664C24.8365 0.430664 32 7.59416 32 16.4307",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIndonesia);
export default __webpack_public_path__ + "static/media/flag_indonesia.796b96a02f16d01bdd5546d131b9b0c2.svg";
export { ForwardRef as ReactComponent };